import { useParams } from '@cedarjs/router'

export const useOrgName = (): string | undefined => {
  const { orgName } = useParams()
  return orgName
}

export default useOrgName
